// Product branding. Neutral default ("Vitals") so the repo stays customer-neutral;
// override per installation at build time via VITE_APP_NAME / VITE_APP_SUBTITLE.
// `||` (not `??`) so an empty build-arg ("") also falls back to the neutral default.
export const APP_NAME: string = import.meta.env.VITE_APP_NAME || 'Vitals'
export const APP_SUBTITLE: string = import.meta.env.VITE_APP_SUBTITLE || 'Operations'

// Support contact shown on the gate pages (pending / access denied). Neutral
// default; override per installation via VITE_SUPPORT_EMAIL.
export const SUPPORT_EMAIL: string = import.meta.env.VITE_SUPPORT_EMAIL || 'support@example.com'

// Operating company name, used in neutral copy like "Technische Ansprechpartner
// bei <Firma>". Empty by default so no customer name leaks; set VITE_COMPANY_NAME
// per installation. Helper appends " bei <name>" only when configured.
export const COMPANY_NAME: string = import.meta.env.VITE_COMPANY_NAME || ''
export const companySuffix = (): string => (COMPANY_NAME ? ` bei ${COMPANY_NAME}` : '')

// Deployed build identifier = short commit SHA of the deployed state, stamped by
// deploy/rollout.sh into VITE_BUILD_ID at build time (#59). Falls back to "dev" for
// local `npm run dev`. VITE_BUILD_TIME is the optional UTC rollout timestamp.
export const BUILD_ID: string = import.meta.env.VITE_BUILD_ID || 'dev'
export const BUILD_TIME: string = import.meta.env.VITE_BUILD_TIME || ''
